import { Component, OnInit, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import * as fileSaver from 'file-saver';


import { Observable} from 'rxjs';
import { GlobalService } from '../global-service.service';

@Component({
    selector: 'app-file-archiv',
    templateUrl: './file-archiv.component.html',
    styleUrls: ['../css/pasura.css'],
    standalone: false
})

@Injectable({ providedIn: 'root' })
export class FileArchivComponent implements OnInit {

  constructor( private globserv: GlobalService,  private http:HttpClient) { }

  ngOnInit(): void 
  {
  		this.getFileArchiv();
  }
  		
  
  FileSelect = {	"Alle": false,
  						"Adressen": true,
  						"Antrag": false,
  						"Schadenfall": false,
  						"Transportversicherung":false,
  						"Pferdestatistik":false,
  						"Jahr": true,
  						"lJahr": false,
  					};
  
  
  fileList:any;
  
  downloadFile(fileID):any{	
  			
		return this.http.get("/api/v1/getFile?fileID=" +fileID, {responseType: 'blob'});
  }
   
   /*
   
   isSelected(key)
   {
   	return this.FileSelect.includes(key);
   }
  
  
   toggelFileSelect_(key)
   {
   
   	if (this.FileSelect.includes(key))
   	{
   		var idx= this.FileSelect.findIndex(selec => selec === key);
   		this.FileSelect.splice(idx, 1);
   		
   	}else{
   		this.FileSelect.push(key);
   	}
   	
   	console.log(this.FileSelect);
   }
   */
   
   checkAlle(key)
   {
   	
   	if(key=='Alle')
   	{
   		this.FileSelect[key]=true;
   	}else{
   		this.FileSelect[key]=(!this.FileSelect[key]);
   	}
   	console.log(key + " -> "+JSON.stringify(this.FileSelect));
   	
   	if (key=='Jahr' && this.FileSelect.Jahr)
		{
			this.FileSelect.lJahr=false;
					
		}else if (key=='lJahr' && this.FileSelect.lJahr)
		{
			this.FileSelect.Jahr=false;
					
		}else	if(key=="Alle" && this.FileSelect.Alle)
		{
			this.FileSelect.Adressen=false;
			this.FileSelect.Antrag= false;
  			this.FileSelect.Schadenfall= false;
  			this.FileSelect.Transportversicherung=false;
  			this.FileSelect.Pferdestatistik=false;
  			
  			
		}else if(this.FileSelect.Alle)
		{
			this.FileSelect.Alle=false;		
		}
		
		this.getFileArchiv();
   }
   
   log()
   {
   	//key=(!key);
   	
   	console.log(JSON.stringify(this.FileSelect));
   }
  
   getFile(fileID, fileName) {
    this.globserv.runstatus=='running';
    this.downloadFile(fileID).subscribe(response => {
			let blob:any = new Blob([response], { type: 'text/json; charset=utf-8' });
			const url = window.URL.createObjectURL(blob);
			//window.open(url);
			//window.location.href = response.url;
			console.log(response);
			this.globserv.runstatus=='';
			fileSaver.saveAs(blob, fileName);
		}), error => console.log('Error downloading the file'),
                 () => console.info('File downloaded successfully');
  }
  
  
  
  getFileArchiv()
  {
 		var data={"Filter":Object.assign({}, this.FileSelect)};
		var resultData;
		
  		this.globserv.getBackendData("/v1/getFileArchiv", data).subscribe(
		result => resultData=result, 
		 	
  					 err => {
  					 				this.globserv.setPasuraAction({"msg":{"title":"Fehlmeldung","txt":"Fehler beim suchen der Archiv-Files!"}});	
  					 				console.log("Error");
	  					 			console.log(err);  					 				
  					 		  },
		       () => {
					this.fileList = resultData.FileArchivList;
	       		//console.log("Files " +JSON.stringify(this.fileList));
			}
		);   
  }
}
